// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2-gXQ","rootSmall":"AddTileButton_rootSmall__LybSq"};